var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('circle',{style:({ fill: _vm.color }),attrs:{"cx":"53.8","cy":"63.8","r":"50"}})}
var staticRenderFns = []

export { render, staticRenderFns }